import { useCurrentClient } from '@mysten/dapp-kit-react'
import { useQuery } from '@tanstack/react-query'

/**
 * Reverse-resolves a Sui address to its default SuiNS name.
 * Drop-in replacement for the removed dapp-kit `useResolveSuiNSName` hook,
 * backed by the gRPC name service (`client.core.defaultNameServiceName`).
 * Pass `null` to disable the query.
 */
export const useResolveSuiNSName = (address: string | null) => {
  const client = useCurrentClient()

  return useQuery({
    queryKey: ['resolveSuiNSName', address],
    enabled: !!address,
    queryFn: async () => {
      try {
        const res = await client.core.defaultNameServiceName({ address: address! })
        return res.data.name
      } catch {
        // Reverse SuiNS lookup is cosmetic: the gRPC name service throws for
        // addresses with no name (NOT_FOUND), an expired name ("name has expired"),
        // and likely other variants. Any failure just means "show the raw address".
        return null
      }
    },
  })
}
